import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Calculations {
  currentMonthlyPayment: number;
  proposedMonthlyPayment: number;
  totalSavings: number;
  monthlyInterest: number;
  annualInterest: number;
  creditUtilization: number;
  paymentBreakdown?: {
    interestPayment: number;
    principalPayment: number;
  };
}

interface PresentationState {
  currentSlide: number;
  clientName: string;
  sessionDate: string;
  selectedTerms: number;
  additionalPayment: number;
  calculations: Calculations;
  cursorControlEnabled: boolean;
  cursorPosition: {
    x: number;
    y: number;
  };
  hoveredProgramStep: number | null;
}

const initialState: PresentationState = {
  currentSlide: 0,
  clientName: '',
  sessionDate: new Date().toISOString(),
  selectedTerms: 36,
  additionalPayment: 100,
  calculations: {
    currentMonthlyPayment: 0,
    proposedMonthlyPayment: 0,
    totalSavings: 0,
    monthlyInterest: 0,
    annualInterest: 0,
    creditUtilization: 0
  },
  cursorControlEnabled: false,
  cursorPosition: {
    x: 0,
    y: 0
  },
  hoveredProgramStep: null
};

const presentationSlice = createSlice({
  name: 'presentation',
  initialState,
  reducers: {
    setCurrentSlide: (state, action: PayloadAction<number>) => {
      state.currentSlide = action.payload;
    },
    setClientName: (state, action: PayloadAction<string>) => {
      state.clientName = action.payload;
    },
    setSelectedTerms: (state, action: PayloadAction<number>) => {
      state.selectedTerms = action.payload;
    },
    updateCalculations: (state, action: PayloadAction<Partial<Calculations>>) => {
      state.calculations = { ...state.calculations, ...action.payload };
    },
    setAdditionalPayment: (state, action: PayloadAction<number>) => {
      state.additionalPayment = action.payload;
    },
    toggleCursorControl: (state) => {
      state.cursorControlEnabled = !state.cursorControlEnabled;
    },
    updateCursorPosition: (state, action: PayloadAction<{ x: number; y: number }>) => {
      state.cursorPosition = action.payload;
    },
    setHoveredProgramStep: (state, action: PayloadAction<number | null>) => {
      console.log('Redux: Setting hoveredProgramStep to:', action.payload);
      state.hoveredProgramStep = action.payload;
    },
  }
});

export const {
  setCurrentSlide,
  setClientName,
  setSelectedTerms,
  setAdditionalPayment,
  setHoveredProgramStep,
  updateCalculations,
  toggleCursorControl,
  updateCursorPosition
} = presentationSlice.actions;

export default presentationSlice.reducer;
